module.exports = __webpack_public_path__ + "static/media/boomea-blue.cd7376a3.svg";